<template>
  <div class="page_background">
      <div class="heading"> {{ $t('auth_page.title') }} </div>
      <p> {{ $t('auth_page.description') }} </p>
      <div >
        <v-btn class="btn-new mr-2" @click="cognitoLogin" color="#9B004B">
          <div style="color:white;">Login</div>
        </v-btn>
        <v-btn class="btn-new" @click="cognitoLogin">
          <div style="color:black;">Registrieren</div>
        </v-btn>
      </div>
  </div>
</template>

<script>
import auth from '../cognito-auth/cognitoAuth';

  export default {
    name: "AuthPage",
    methods: {
      cognitoLogin(){
        auth.auth.getSession();
      }
    }
  }
</script>

<style scoped>
  .btn-new {
    border: none;
    cursor: pointer;
    border-radius: 8px;
    width: 158px;
    height: 38px;
    letter-spacing: 0px;
    font-size: 17px;
  }

</style>